import type { LocaleMessageValue, VueMessageType } from 'vue-i18n';

/**
 * @deprecated This is a little bit hacky and should be replaced by native vue-i18n functionality when possible
 */
export const mapI18NResolvedArrayToArray = (array: LocaleMessageValue<VueMessageType>): any => {
  if (typeof array === 'string') {
    return array;
  }

  // Using local message files returns a different data structure containing additional meta information,
  // which is not the case when using remote i18n messages. Try the file based format first, then fallback.
  return array.map((item: VueMessageType) => {
    if (typeof item === 'string') {
      return item;
    }

    if ('loc' in item) {
      return item.loc?.source || item;
    }

    return item;
  });
};

export const getI18nObject = (messageKey: string, recursiveKey?: string): Record<string, any> => {
  const app = useNuxtApp();

  return app.$i18n.tm(messageKey)?.map((i18nObj: LocaleMessageValue<VueMessageType>) => {
    const translatedObj = {};
    Object.keys(i18nObj).forEach((key) => {
      if (key === recursiveKey && Array.isArray(i18nObj[key])) {
        translatedObj[key] = i18nObj[key]?.map((subreason) => {
          const translatedSubreason = {};
          Object.keys(subreason)?.forEach((subKey) => {
            translatedSubreason[subKey] = app.$i18n.rt(subreason[subKey]);
          });
          return translatedSubreason;
        });
      } else {
        translatedObj[key] = app.$i18n.rt(i18nObj[key]);
      }
    });
    return translatedObj;
  });
};
